var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NuxtLink',{staticClass:"header-logo",attrs:{"to":"/","data-external":"header-logo"}},[_c('nuxt-img',{staticClass:"logo",attrs:{"src":"/amx-logo.svg","alt":"AMX logo","format":"svg","sizes":"sm:250px lg:400px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }